module.exports = __webpack_public_path__ + "dist/assets/techsee.4978c70ccb07b2fd1c560721dad2eb3a.png";